'use client';

import { ServiceModules, type ServiceModulesContent } from '../components';

const BRAND_DESIGN_SERVICE_CONTENT: ServiceModulesContent = {
  layout: {
    nextLink: '/airtime',
    hoverTextColor: 'text-at',
    logoColor: 'text-at',
  },
  hero: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/brand_waves.png',
    headingStatement: 'Bringing startup visions to life',
    headingStatementLines: ['Bringing', 'startup\u00A0visions', 'to life'],
    heading: 'Brand + Design',
    headingLargeText:
      "Strong brands soar, weak brands fizzle. But most startups aren't founded by brand experts, so bridging the product/market gap can be one of the biggest challenges a young company faces.",
    headingSmallText:
      'A distinctive name and appealing logo are only the beginning. A strong brand communicates with clarity and intent: resonating with the public, setting expectations, and shaping every interaction that follows.',
    imageTopOffset: 576,
  },
  teamProof: {
    text: "From workplace tools to healthcare and quality-of-life products, we've founded, developed, or enhanced dozens of brands solving real problems and making a real difference.",
  },
  whatWeDo: {
    thinTitle: undefined,
    boldTitle: 'Getting to the heart of things',
    textParagraphs: [
      'We approach every brand project with a thorough understanding of what a company is, what value it adds to the world, and why it matters. Then we create identities, systems, and content that tell the story simply and beautifully.',
    ],
    ctaText: "Let's build your brand",
    ctaLink: 'mailto:hello@all-turtles.com?subject=Brand%20and%20Design%20inquiry',
    rightColumnItems: [
      {
        heading: 'Brand identity',
        paragraph:
          'Even with a great product, it’s easy to get lost in the noise. Our deeply experienced team creates brand names that sing, logos that linger, and positioning that hits the sweet spot.',
      },
      {
        heading: 'Visual design systems',
        paragraph:
          'Today’s hot trend is tomorrow’s dinosaur. We dig down to the bedrock of your company and audience, crafting design frameworks that feel fresh, on-target, and built to last.',
      },
      {
        heading: 'Content design',
        paragraph:
          'Brand and design don’t matter unless they inspire action. We build websites and experiences that meet people where they are and guide them smoothly from curiosity to engagement.',
      },
    ],
  },
  whatMakesUsUnique: {
    points: [
      {
        boldPhrase: 'Zero to one, and beyond',
        description:
          'We know startups, and we’ve also built our own. Whether you’re saying hello to the world or extending an existing brand, we know what’s needed (and what’s nonsense).',
      },
      {
        boldPhrase: 'A focus on clarity',
        description:
          'The deeper the “why,” the more meaning comes across. We collaborate deeply with studio companies to ensure that everything we build serves a purpose and tells a unified story.',
      },
      {
        boldPhrase: 'Rapid iteration',
        description:
          'We move fast, but we know the work isn’t done at launch. Several of our studio companies keep us involved with the long-term evolution of their brands, taking the load off internal teams.',
      },
    ],
  },
  allTurtlesInAction: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/brand_airtime.png',
    mobileBackgroundImage: '/images/services/brand_airtime.png',
    title: 'Evolving Airtime',
    paragraphs: [
      'When All Turtles created mmhmm in 2020 to improve video meetings, the idea of working over video was still alien to many people. Remote work meant navigating a strange new world, and mmhmm pointed the way to clarity.',
      "Five years later, video communication was the norm for distributed teams, the creator economy, online education, sales, and more. With new modes of working and a rapidly expanding set of tools, All Turtles' design team was tapped to shape a new identity for the future.",
      "Reinventing mmhmm as Airtime, we worked in tandem with the company's product design team to ensure each side's evolution reinforced the other, and would continue to do so as new tools were introduced. We stripped the brand down to its essence, relentlessly optimizing for clarity without sacrificing its DNA—smooth professionalism balanced with boundless personal expression.",
      "Airtime's toolkit of apps foster attention, engagement, and understanding in every context, so the new brand did the same, pushing the message boldly forward while pulling back visual noise to let user contexts and content shine.",
    ],
    testimonialPhoto: '/images/services/brand_christine.jpg',
    testimonialPhotoAlt: 'Christine Foote, Head of Marketing, Airtime',
    testimonialQuote:
      'As our embedded design partner at Airtime over the years, All Turtles’ breadth of talent—from illustration, to motion, editorial to web and beyond—has helped us craft world-class creative. They consistently bring heart, taste, and clarity to everything we make together.',
    testimonialPerson: 'Christine Foote',
    testimonialTitle: 'Head of Marketing, Airtime',
  },
};


export const ServicePage = () => {
  return <ServiceModules content={BRAND_DESIGN_SERVICE_CONTENT} />;
};
